export default "__VITE_ASSET__DcJ943gK__"